import { Stack, Typography, styled, lighten } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

import { FONT_COLORS } from "../../../../constants";

type TPricingPlanFeatureItemProps = {
  text: string;
};

const StyledIconContainer = styled(Stack)(() => ({
  justifyContent: "center",
  alignItems: "center",
  width: 20,
  height: 20,
  borderRadius: "100%",
  backgroundColor: lighten(FONT_COLORS.info, 0.9),
}));

export const PricingPlanFeatureItem = ({
  text,
}: TPricingPlanFeatureItemProps) => {
  return (
    <Stack direction="row" gap={0.6}>
      <StyledIconContainer>
        <CheckIcon sx={{ width: 13, height: 13, color: FONT_COLORS.info }} />
      </StyledIconContainer>
      <Typography fontSize={14} fontWeight={400}>
        {text}
      </Typography>
    </Stack>
  );
};
